import * as React from "react";
import { useLocation } from "react-router-dom";

/**
 * Which section a route belongs to. Single source of truth for the mapping -
 * both the MUI palette (src/MUIThemProvider.js) and the body theme scope below
 * read it, so they can never disagree about where the user is.
 */
export const sectionFor = (pathname) => {
    if (pathname.startsWith("/admin")) return "teacher";
    if (pathname.startsWith("/dashboard")) return "student";
    return "landing";
};

const SECTION_CLASS = {
    landing: "theme-landing",
    teacher: "theme-teacher",
    student: "theme-student",
};

const ALL_CLASSES = Object.values(SECTION_CLASS);

/**
 * Mirrors the current section's accent onto <body>.
 *
 * The .admin / .dashboard classes on the layout roots already scope the accent
 * for normal content, but MUI mounts Modal, Select, Menu, Drawer, Tooltip,
 * Popover and Snackbar into a portal on document.body - outside those subtrees.
 * Portal content therefore inherited the :root fallback and rendered in landing
 * blue no matter which section it was opened from (admin modal buttons being
 * the obvious symptom).
 *
 * Putting the scope on <body> puts it above both the layout roots and the
 * portal container, so everything resolves to the same accent. Renders nothing.
 */
export function SectionThemeScope() {
    const { pathname } = useLocation();

    React.useEffect(() => {
        const next = SECTION_CLASS[sectionFor(pathname)];
        document.body.classList.remove(...ALL_CLASSES);
        document.body.classList.add(next);
        return () => document.body.classList.remove(next);
    }, [pathname]);

    return null;
}
